import React, { useState } from 'react';
import { Container, Typography, Box, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ClientForm from '../components/clients/ClientForm';

const NewClient = () => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (formData) => {
    setSubmitting(true);
    setError(null);
    
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.post('/api/clients', formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.status === 'success') {
        // Navegar para a página de detalhes do novo cliente
        navigate(`/clients/${response.data.data.client._id}`);
      }
    } catch (error) {
      console.error('Error creating client:', error);
      setError(error.response?.data?.message || 'Erro ao criar cliente. Por favor, tente novamente.');
      setSubmitting(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Novo Cliente
      </Typography>
      
      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}
      
      <ClientForm 
        onSubmit={handleSubmit} 
        isSubmitting={submitting}
        buttonText="Criar Cliente" 
      />
    </Container>
  );
};

export default NewClient;
